import {
  type Action,
  type ControlType,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

type BaseGamePageV3Extras = {
  id: string;
  gameId?: string;
  gameName?: string;
  imageIndex?: string;
  questId?: string;
};

type GamePageV3ViewedEvent = {
  action: Action.VIEWED;
  extras: BaseGamePageV3Extras;
};

type GamePageV3PressedEvent = {
  action: Action.PRESSED;
  extras: BaseGamePageV3Extras & {
    control: string;
    controlType: ControlType;
  };
};

type GamePageV3SucceededEvent = {
  action: Action.SUCCEEDED;
  extras: BaseGamePageV3Extras;
};

type GamePageV3FailedEvent = {
  action: Action.FAILED;
  extras: BaseGamePageV3Extras;
};

export type GamePageV3Event =
  | GamePageV3ViewedEvent
  | GamePageV3PressedEvent
  | GamePageV3SucceededEvent
  | GamePageV3FailedEvent;

export const useGamePageV3Analytics = () =>
  useAnalyticsTracker<GamePageV3Event>(TrackObject.GAME_PAGE_V3);
